module.exports = __webpack_public_path__ + "static/media/1.df6b0e69.jpg";